import styled from 'styled-components';

const Style = styled.div`
  position: relative;

  .react-flow__pane {
    background: #FAFAFA;
    border-radius: 4px;
  }

  .react-flow__node {
    outline: none !important;
    border: 0px !important;
    box-shadow: none !important;
  }

  .react-flow__node-default{
    &:hover {
      box-shadow: unset !important;
      border: 0px !important;
    }
  }

  .react-flow__handle-left {
    opacity: 0;
    width: 7px;
    height: 7px;
    transition: .4s opacity;
    background: white;
    border: 2px solid #C0C0C0;
  }

  .react-flow__handle-right {
    opacity: 0;
    width: 7px;
    height: 7px;
    transition: .4s opacity;
    background: white;
    border: 2px solid #C0C0C0;
  }

  .node-active { 
    background: white;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.12) !important;

    .react-flow__handle-right, .react-flow__handle-left {
      opacity: 1;
    }

    &:hover {
      background: white;
      box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.12) !important;
    }

    &.own-data {
      .react-flow__handle-left {
        opacity: 0;
      }
    }

    &.last-level {
      .react-flow__handle-right {
        opacity: 0;
      }
    }
  }

  .active-node {
    position: absolute;
    bottom: 34px;
    right: 40px;
    z-index: 500;
    background: white;
    padding: 20px 12px 15px 12px;
    box-shadow: 0px 5px 11px -1px rgba(0, 0, 0, 0.18);
    display: flex;
    flex-direction: column;
    min-width: 200px;
    max-width: 250px;

    .active-node-header {
      display: flex;

      .main {
        flex: 1;
        label { 
          font-size: 12px;
          color: #AEAEAE;
          font-weight: 700;
        }

        h1 {
          font-size: var(--font-size-lg);
          font-weight: 500;
        }
      }

      svg {
        width: 12px;
        height: 12px;
        color: #C4C4C4;
        cursor: pointer;
        margin-left: 10px;
      }
    }

    .ant-btn {
      border: 1px solid var(--color-primary-70);
    }

    .sources {
      display: flex;
      flex-direction: column;
      gap: 12px;

      h3 {
        font-size: 14px;
        font-weight: 700;
        margin-bottom: 0px;
      }

      .source {
        display: flex;
        flex-direction: column;
        border-top: 1px solid #F0F0F0;

        .source-header {
          display: flex;
          gap: 4px;
          padding: 12px 0px;

          svg, .legend {
            width: 10px;
            margin-top: 2px;
            height: 10px;
          }

          .legend {
            border-radius: 100%;
          }

          h4 {
            font-size: 14px;
            font-weight: 500;
            margin-bottom: 0px;
          }
        }

      }
    }
  }  
`;

export default Style;
